export function isNullish(v) {
  return v === null || v === undefined;
}

export function isNotNullish(v) {
  return v !== null && v !== undefined;
}
